module.exports = __webpack_public_path__ + "16e1d930cf13fb7a956372044b6d02d0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/roboto.woff
// module id = 589
// module chunks = 0